import React from "react";
import { Box, Tooltip } from "@outschool/backpack";
import LoginUserFeedback from "./LoginUserFeedback";
import { useTranslation } from "@outschool/localization";

export interface TurnstileWidgetProps {
  turnstileSitekey: string | undefined;
  id: string;
  hasError: boolean;
}

export function TurnstileWidget({
  turnstileSitekey,
  id,
  hasError,
}: TurnstileWidgetProps) {
  const { t } = useTranslation("ui-auth\\src\\TurnstileWidget");
  return (
    <>
      {Boolean(turnstileSitekey) && hasError && (
        <Tooltip
          title={t(
            "You may need to disable browser extensions like adblockers or parental controls for outschool.com and challenges.cloudflare.com. You can also use one of our social login options, or contact support@outschool.com if you continue to see this message.",
          )}
        >
          <Box>
            <LoginUserFeedback
              isError={true}
              userFeedbackMessage={t(
                "Your device failed an integrity check. Please refresh the page to try again.",
              )}
            ></LoginUserFeedback>
          </Box>
        </Tooltip>
      )}
      <div style={{ display: "block", flexFlow: "row" }}>
        {Boolean(turnstileSitekey) && (
          <div className="cf-turnstile" id={id} data-size="flexible"></div>
        )}
      </div>
    </>
  );
}
